var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Benefit"},[_c('img',{staticClass:"Benefit__img",attrs:{"src":_vm.img}}),_c('h3',{staticClass:"Benefit__title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"Benefit__text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }